var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import AnalysisTaskConstants from "./AnalysisTaskConstants.js";
import { AsyncRequestStatus } from "@ane/core/lib/models";
const getDefaultState = () => {
  return {
    taskResubmitState: AsyncRequestStatus.NotStarted,
    tasksBeingResubmitted: null,
    taskCancelState: AsyncRequestStatus.NotStarted,
    tasksBeingCancelled: null
  };
};
const resubmitTask = (state, taskIds) => {
  return __spreadProps(__spreadValues({}, state), {
    taskResubmitState: AsyncRequestStatus.Pending,
    tasksBeingResubmitted: taskIds
  });
};
const resubmittingTask = (state) => {
  return __spreadProps(__spreadValues({}, state), {
    taskResubmitState: AsyncRequestStatus.Pending
  });
};
const resubmittedTask = (state) => {
  return __spreadProps(__spreadValues({}, state), {
    taskResubmitState: AsyncRequestStatus.Completed
  });
};
const cancelTask = (state, taskIds) => {
  return __spreadProps(__spreadValues({}, state), {
    taskCancelState: AsyncRequestStatus.Pending,
    tasksBeingCancelled: taskIds
  });
};
const cancellingTask = (state) => {
  return __spreadProps(__spreadValues({}, state), {
    taskCancelState: AsyncRequestStatus.Pending
  });
};
const cancelledTask = (state) => {
  return __spreadProps(__spreadValues({}, state), {
    taskCancelState: AsyncRequestStatus.Completed
  });
};
const resetTaskActions = (state) => {
  return __spreadProps(__spreadValues({}, state), {
    taskResubmitState: AsyncRequestStatus.NotStarted,
    tasksBeingResubmitted: null,
    taskCancelState: AsyncRequestStatus.NotStarted,
    tasksBeingCancelled: null
  });
};
const AnalysisTaskReducer = (state = getDefaultState(), actionResult) => {
  switch (actionResult.type) {
    case AnalysisTaskConstants.RESUBMIT_TASK:
      return resubmitTask(state, actionResult.payload.TaskIds);
    case AnalysisTaskConstants.RESUBMITTING_TASK:
      return resubmittingTask(state);
    case AnalysisTaskConstants.RESUBMITTED_TASK:
      return resubmittedTask(state);
    case AnalysisTaskConstants.CANCEL_TASK:
      return cancelTask(state, actionResult.payload.TaskIds);
    case AnalysisTaskConstants.CANCELLING_TASK:
      return cancellingTask(state);
    case AnalysisTaskConstants.CANCELLED_TASK:
      return cancelledTask(state);
    case AnalysisTaskConstants.RESET_TASK_ACTIONS:
      return resetTaskActions(state);
    default:
      return state;
  }
};
export {
  AnalysisTaskReducer,
  AnalysisTaskReducer as default,
  getDefaultState
};
//# sourceMappingURL=AnalysisTaskReducer.js.map
